<template>
  <div class="sc-sale-ranking">
    <div class="inner">
      <div class="title">
        <div class="left">
          <img class="icon" src="@/assets/圆圈.png" alt />
          <div class="name">排行榜</div>
        </div>
        <div class="right">
          <ScDatePicker v-if="date" :date="date" @change="onChange" />
        </div>
      </div>

      <div class="charts">
        <div class="left">
          <div class="title">省区销售龙虎榜</div>
          <v-chart :options="provinceOption" v-if="provinceArray.length > 0" />
          <NoData title="所选日期暂无销售数据" v-else />
        </div>
        <div class="right">
          <div class="title">门店销售龙虎榜</div>
          <v-chart :options="shopOption" v-if="shopArray.length > 0" />
          <NoData title="所选日期暂无销售数据" v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from "./NoData";
import ScDatePicker from "./ScDatePicker";
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import echarts from "echarts";

import util from "@/plugins/util";

let unit = "";

export default {
  name: "ScSaleRanking",
  components: {
    ScDatePicker,
    NoData,
    "v-chart": ECharts
  },
  props: {
    code: {
      type: String,
      required: true
    },
    categoryCode:{
        type: String,
        required: true
    }
  },
  data() {
    return {
      date: false,
      provinceArray: [],
      shopArray: [],
      provinceOption: {
        grid: {
          top: 0,
          bottom: 20,
          right: 540 * 0.1,
          left: 12 * 5,
          containLabel: false,
          borderWidth: 0,
          borderColor: "#eee"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            lineStyle: {
              color: "#01B484"
            }
          },
          // position: function(point, params, dom, rect, size) {
          //   // console.log(point, params, dom, rect, size);
          //   // 固定在顶部
          //   return [point[0], "10%"];
          // },
          backgroundColor: "#fff",
          padding: 15,
          textStyle: {
            color: "#999",
            fontSize: 12,
            fontFamily: "DIN Medium",
            lineHeight: 20
          },
          extraCssText: "box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);",
          formatter: function(params) {
            // console.log(params);
            const e = params[0].data.item;
            return (
              "<div style='color: #1B994F;'>销售量：</div>" +
              `<div style='color: #1B994F; height: 30px; line-height: 30px; font-size: 20px'>${util.formatMoney(
                e.quantity,
                2,
                ""
              )}${e.unit}</div>` +
              `<div style='color: #999'>销售额：<span style='color: #444;'>${util.formatMoney(
                e.amount,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>平均价：<span style='color: #444;'>${util.formatMoney(
                e.price,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利额：<span style='color: #444;'>${util.formatMoney(
                e.profit,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利率：<span style='color: #444;'>${util.formatMoney(
                e.profitRate * 100,
                2,
                ""
              )}%</span></div>`
            );
          }
        },
        yAxis: {
          type: "category",
          data: [],
          axisLine: {
            lineStyle: {
              color: "rgba(0, 0, 0, 0.25)"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: "#848791",
            formatter: function(val) {
              const arr = val.split("--");
              if (arr.length > 1) {
                return arr[0] + "\n" + arr[1];
              } else {
                if (val.length > 4) {
                  const head = val.substring(0, 4);
                  const last = val.substring(4, 8);

                  return head + "\n" + last;
                } else {
                  return val;
                }
              }
            },
            // height: 32,
            lineHeight: 16
          }
        },
        xAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: "rgba(0, 0, 0, 0.09)",
              type: "dashed"
            }
          },
          axisLabel: {
            color: "#848791",
            formatter: function(val) {
              return util.formatMoney(val, 0, "") + unit;
            }
          }
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: "#4CB0FD" },
                  { offset: 1, color: "#4A8EFD" }
                ])
              }
            },
            barWidth: 16,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#333",
                  fontSize: 12,
                  fontWeight: 600,
                  fontFamily: "DIN Medium"
                },
                position: "right",
                formatter: function(data) {
                  return util.formatMoney(data.value, 2, "￥");
                }
              }
            },
            emphasis: {}
          }
        ]
      },
      shopOption: {
        grid: {
          top: 0,
          bottom: 20,
          right: 540 * 0.1,
          left: 12 * 9,
          containLabel: false,
          borderWidth: 0,
          borderColor: "#eee"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            lineStyle: {
              color: "#01B484"
            }
          },
          // position: function(point, params, dom, rect, size) {
          //   // console.log(point, params, dom, rect, size);
          //   // 固定在顶部
          //   return [point[0], "10%"];
          // },
          backgroundColor: "#fff",
          padding: 15,
          textStyle: {
            color: "#999",
            fontSize: 12,
            fontFamily: "DIN Medium",
            lineHeight: 20
          },
          extraCssText: "box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);",
          formatter: function(params) {
            // console.log(params);
            const e = params[0].data.item;
            return (
              "<div style='color: #1B994F;'>销售量：</div>" +
              `<div style='color: #1B994F; height: 30px; line-height: 30px; font-size: 20px'>${util.formatMoney(
                e.quantity,
                2,
                ""
              )}${e.unit}</div>` +
              `<div style='color: #999'>销售额：<span style='color: #444;'>${util.formatMoney(
                e.amount,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>平均价：<span style='color: #444;'>${util.formatMoney(
                e.price,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利额：<span style='color: #444;'>${util.formatMoney(
                e.profit,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利率：<span style='color: #444;'>${util.formatMoney(
                e.profitRate * 100,
                2,
                ""
              )}%</span></div>`
            );
          }
        },
        yAxis: {
          //   type: "category",
          data: [],
          axisLine: {
            lineStyle: {
              color: "rgba(0, 0, 0, 0.25)"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: "#848791",
            formatter: function(val) {
              const arr = val.split("--");
              if (arr.length > 1) {
                return arr[0] + "\n" + arr[1];
              } else {
                if (val.length > 8) {
                  const head = val.substring(0, 8);
                  const last = val.substring(8, 16);

                  return head + "\n" + last;
                } else {
                  return val;
                }
              }
            },
            // height: 32,
            lineHeight: 16
            // rich: {
            //   a: {}
            // }
          }
        },
        xAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: "rgba(0, 0, 0, 0.09)",
              type: "dashed"
            }
          },
          axisLabel: {
            color: "#848791",
            formatter: function(val) {
              return util.formatMoney(val, 0, "") + unit;
            }
          }
        },
        series: [
          {
            data: [],
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: "#F7AA16" },
                  { offset: 1, color: "#F27C07" }
                ])
              }
            },
            barWidth: 16,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#333",
                  fontSize: 12,
                  fontWeight: 600,
                  fontFamily: "DIN Medium"
                },
                position: "right",
                formatter: function(data) {
                  return util.formatMoney(data.value, 2, "￥");
                }
              }
            }
          }
        ]
      }
    };
  },
  created() {
    this.getProvinceData().then(() => {
      this.drawProvinceData();
    });
    this.getShopData().then(() => {
      this.drawShopData();
    });
  },
  methods: {
    async getProvinceData(date) {
      const response = await this.ajax.doPost({
        packageName: "sc",
        className: "scSaleProvince",
        methodName: "latest",
        params: {
          code: this.code,
          categoryCode:this.categoryCode,
          saleDate: date ? date : null,
          numPerPage: 10
        }
      });

      this.provinceArray = response.results;

      if (!date && this.provinceArray.length > 0) {
        this.date = new Date(this.provinceArray[0].saleDate);
        unit = this.provinceArray[0].unit;
      }
    },
    async getShopData(date) {
      const response = await this.ajax.doPost({
        packageName: "sc",
        className: "scSaleShop",
        methodName: "latest",
        params: {
          code: this.code,
          categoryCode:this.categoryCode,
          saleDate: date ? date : null,
          numPerPage: 10
        }
      });

      this.shopArray = response.results;

      if (!date && this.shopArray.length > 0) {
        this.date = new Date(this.shopArray[0].saleDate);
        unit = this.shopArray[0].unit;
      }
    },
    drawProvinceData() {
      if (this.provinceArray.length > 0) {
        const data = this.provinceArray.filter(e => e.amount > 0).reverse();
        this.provinceOption.yAxis.data = data.map(e => e.province);
        this.provinceOption.series[0].data = data.map(e => {
          return {
            value: e.amount,
            item: e
          };
        });
      }
    },
    drawShopData() {
      if (this.shopArray.length > 0) {
        const data = this.shopArray.filter(e => e.amount > 0).reverse();
        this.shopOption.yAxis.data = data.map(e => e.shop);
        this.shopOption.series[0].data = data.map(e => {
          return {
            value: e.amount,
            item: e
          };
        });
      }
    },
    onChange(e) {
      this.getProvinceData(e).then(() => {
        this.drawProvinceData();
      });
      this.getShopData(e).then(() => {
        this.drawShopData();
      });
    }
  }
};
</script>

<style lang="scss">
.sc-sale-ranking {
  width: 100%;

  .inner {
    width: 1100px;
    margin: 0 auto;

    .chart {
      width: 100%;
      height: 400px;
    }

    .echarts {
      width: 100%;
      height: 100%;
    }

    .title {
      margin: 20px 0 10px 0;
      height: 40px;

      .left {
        float: left;

        img.icon {
          display: inline-block;
          width: 12px;
          height: 12px;

          margin-right: 10px;
        }

        div.name {
          display: inline-block;

          height: 28px;
          font-size: 20px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
        }
      }
      .right {
        float: right;
      }
    }

    .charts {
      border-top: 1px solid #f4f4f4;
      padding-top: 30px;
      .title {
        height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
        text-align: center;
      }
      .left {
        display: inline-block;

        width: 540px;
        height: 540px;

        padding-right: 9px;

        border-right: 1px solid #f4f4f4;
      }
      .right {
        display: inline-block;

        width: 540px;
        height: 540px;

        padding-left: 10px;
      }
    }
  }
}
</style>